'use client'

import type { TooltipChildrenProps } from '@fukku/tooltip/Tooltip'
import { cx } from 'classix'
import { IconInfoL } from 'icons/components/IconInfoL'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { usePricesStore } from '../../context/PricesProvider'
import styles from './ExtraInfoButton.module.css'

export type ExtraInfoButtonProps = {
	readonly handleOnClick?: () => void
	readonly tooltipProps?: TooltipChildrenProps
}

export const ExtraInfoButton = ({
	handleOnClick,
	...tooltipProps
}: ExtraInfoButtonProps) => {
	const { t } = useLabels()
	const { horizontal = false } = usePricesStore()

	return (
		<button
			type='button'
			onClick={handleOnClick}
			className={cx(styles.button, !horizontal && styles.iconVertical)}
			{...tooltipProps}
		>
			<IconInfoL
				className={styles.icon}
				alt={t('accessibility.priceInformation.icon')}
				height={12}
				width={12}
			/>
		</button>
	)
}
